import {
  FETCH_PREINVOICE_REQUEST,
  FETCH_PREINVOICE_SUCCESS,
  FETCH_PREINVOICE_FAILURE,
} from "./CreateInvoicePreDataTypes";
import api from "../../utils/Api";

export const fetchPreInvoiceRequest = () => {
  return {
    type: FETCH_PREINVOICE_REQUEST,
  };
};

export const fetchPreInvoiceSuccess = (preInvoiceList) => {
  return {
    type: FETCH_PREINVOICE_SUCCESS,
    payload: preInvoiceList,
  };
};

export const fetchPreInvoiceFailure = (error) => {
  return {
    type: FETCH_PREINVOICE_FAILURE,
    payload: error,
  };
};

export const fetchPreInvoice = (
  appointment_id,
  associated_related_party,
  conductappointment_id,
  isEstimate
) => {
  const headers = {
    Authorization:
      "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
  };
  return async (dispatch) => {
    dispatch(fetchPreInvoiceRequest());
    try {
      const response = await api.get(
        "payment/invoice/intialdata/fetch?appointment_id=" +
          appointment_id +
          "&associated_related_party_id=" +
          associated_related_party +
          "&conductappointment_id=" +
          conductappointment_id +
          "&isEstimate=" +
          isEstimate,
        {
          headers: headers,
        }
      );
      const preInvoiceList = response.data.data;
     // console.log("************", preInvoiceList);
      dispatch(fetchPreInvoiceSuccess(preInvoiceList));
    } catch (error) {
      console.log("Redux error - ", error.response);
      const errorMsg = error.message;
      dispatch(fetchPreInvoiceFailure(errorMsg));
    }
  };
};
